var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cta-link-container",class:_vm.$route.meta.theme},[_c('a',{staticClass:"cta-link",class:{ active: _vm.active },on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }